import { Component } from '@angular/core';

@Component({
  selector: 'app-hcm-shell-header',
  templateUrl: './hcm-shell-header.component.html',
  styleUrl: './hcm-shell-header.component.css'
})
export class HcmShellHeaderComponent {
  online: boolean = true;
  constructor() {
    window.addEventListener('online', () => {
      this.online = true;
    })
    window.addEventListener('offline', () => {
      this.online = false;
    });
    this.getStatus();
  }

  getStatus() {
    setInterval(() => {
      this.online = navigator.onLine;
    }, 4000)
  }
}
